import { ViewportScroller } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@app/../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { Subscription } from "rxjs";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrl: "./header.component.css",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
	partner = true;

	langs = [];
	hamburgerOpen = false;
	currentLang: string;

	currentValue: string;
	market: string;
	localizedCountry;
	partnerEmitter: Subscription;

	constructor(
		private router: Router,
		public translate: TranslateService,
		private storageService: StorageManagerService,
		private viewportScroller: ViewportScroller,
		public wcmService: WcmService
	) { }

	ngOnInit() {
		if (environment.languages.includes(this.translate.getBrowserCultureLang())) {
			this.translate.use(this.translate.getBrowserCultureLang());
		} else {
			this.translate.use("en-GB");
		}
		this.currentLang = this.translate.getCurrentLang();
	}

	changeLang(value: string) {
		if (value) {
			this.translate.use(value);
		}
	}

	changeCountry(market: string) {
		this.storageService.setSessionItem(
			SessionKey.GEOLOCATION_MARKET,
			market
		);
		this.localizedCountry = market;
		this.refreshLang(market.toLowerCase());
		this.router.navigateByUrl(`/${market.toLowerCase()}`);
	}

	private refreshLang(market?: string) {
		const mkt = market
			? market.toLowerCase()
			: this.localizedCountry.toLowerCase();
		this.langs = this.translate
			.getLangs()
			.filter(v =>
				mkt === "be"
					? v === "en" || v === "fr"
					: v === mkt || v === "en"
			)

			.sort((a, b) => a.localeCompare(b));

		if (mkt === "fr") {
			this.langs = [];
			this.langs.push("fr");
		}

		if (market === "be") {
			this.langs.push("nl");
		}
		this.translate.use(market.toLowerCase());
		if (market === "be") {
			this.currentValue = "nl";
		} else {
			this.currentValue = market.toLowerCase();
		}
	}

	anchor(company: string) {
		this.viewportScroller.scrollToAnchor(company);
	}

	ngOnDestroy(): void {
		if (this.partnerEmitter) {
			this.partnerEmitter.unsubscribe();
		}
	}
}